import React, { useEffect, useState, useRef, Suspense, lazy } from 'react';

const withLazyUnveil = ( {
	loadComponent,
	l10n,
	height = 500,
	mobileHeight = 700,
	showMobile = true,
	showDesktop = true,
	loadingIndicator = null,
} ) => {
	const LazyUnveil = ( props ) => {
		const ref = useRef( null );
		const [ startedLoading, updateLoading ] = useState( false );
		const [ listenerAttached, updateListenerAttached ] = useState( false );
		const isMobile = window.innerWidth < 768;

		useEffect( () => {
			const handleUnveil = ( { target } ) => {
				if ( target !== ref.current || startedLoading ) {
					return;
				}

				updateLoading( true );
			};
			document.addEventListener( 'lazybeforeunveil', handleUnveil );
			updateListenerAttached( true );

			return () =>
				document.removeEventListener(
					'lazybeforeunveil',
					handleUnveil
				);
		}, [] ); //eslint-disable-line

		if ( ( isMobile && ! showMobile ) || ( ! isMobile && ! showDesktop ) ) {
			return null;
		}

		const finalHeight = isMobile ? mobileHeight : height;

		const units =
			String( finalHeight ).match( /^[0-9]+(.*)$/ )[ 1 ] || 'px';

		const wrapperStyle = {
			height: parseInt( finalHeight ) + units,
			paddingTop: ( parseInt( finalHeight ) / 4 ).toFixed( 2 ) + units,
		};

		// Use preload for bots and crawlers
		const preload = /bot|crawler|spider|crawling/i.test(
			navigator.userAgent
		)
			? ' lazypreload'
			: '';

		const LazyComponent = lazy( loadComponent );

		if ( startedLoading ) {
			return (
				<Suspense
					fallback={
						<div
							className="with-lazy-unveil lazyloaded suspense-loading"
							style={ wrapperStyle }
						>
							{ loadingIndicator }
						</div>
					}
				>
					<div className="with-lazy-unveil lazyloaded suspense-loaded">
						<LazyComponent { ...props } l10n={ l10n } />
					</div>
				</Suspense>
			);
		}

		return (
			<div
				ref={ ref }
				className={ `with-lazy-unveil ${
					listenerAttached ? 'lazyload' + preload : ''
				}` }
				style={ wrapperStyle }
			>
				{ loadingIndicator }
			</div>
		);
	};

	return LazyUnveil;
};

export default withLazyUnveil;
